<template>
  <section @click="handleClick">
    <p class="b-text-primary" :class="$style.description" v-dompurify-html="description" />
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { LEGAL_DOCUMENT_TYPE } from '@/lib/consts.ts'

export default defineComponent({

  emits: [
    'linkClicked',
  ],
  name: 'components.shared.agreement-text',

  props: {
    description: {
      type: String,
    },
  },

  methods: {
    handleClick (event) {
      if (event.target.tagName === 'A') {
        const documentType = this.getDocumentType(event.target.href)
        this.$emit('linkClicked', {
          event,
          href: event.target.href,
          documentType,
        })
      }
    },

    getDocumentType (href) {
      if (href.includes('/terms/')) {
        return LEGAL_DOCUMENT_TYPE.TERMS_OF_USE
      }
      if (href.includes('/privacy/')) {
        return LEGAL_DOCUMENT_TYPE.PRIVACY_POLICY
      }
      if (href.includes('/info/') || href.includes('/information-obligation')) {
        return LEGAL_DOCUMENT_TYPE.INFORMATION_OBLIGATION
      }
      return null
    },
  },
})

</script>

<style lang="scss" module>
@layer legacy-views {

.description {
  a {
    text-decoration: underline;
  }
}

}</style>
